import { useMemo } from "react";
import {
  IconNameEnum,
  useHotelsStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";

import { useChildAgePicker } from "@tenant/hotels";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTrigger,
  Icon,
  Popover,
  PopoverContent,
  PopoverTrigger,
  RadioGroup,
} from "@tenant/ui";

import defaultStyles from "./ChildAgePicker.module.scss";

export interface ChildAgePickerComponentProps extends PlatformComponentProps {
  onAgeSelectHandler: (age: number) => void;
  childAge: number;
  label?: string;
}
export const ChildAgePicker = (props: ChildAgePickerComponentProps) => {
  const COMPONENT_KEY = CoreHotelsComponent.ChildAgePicker;
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { context, handlers, text } = useChildAgePicker(props);

  const childAgeButton = useMemo(
    () => (
      <>
        {text.dialogTriggerLabel}
        <Icon
          className={cn("dialog-select-icon")}
          iconName={IconNameEnum.dropdownTriangle}
        />
      </>
    ),
    [cn, text.dialogTriggerLabel]
  );

  const childAgeRadio = useMemo(
    () => (
      <RadioGroup
        className={cn("radio")}
        options={context.ageOptions}
        selectedOption={context.childAgeString}
        onSelectValue={(value) => {
          handlers.onAgeSelectHandler(Number(value));
        }}
      />
    ),
    [cn, context.ageOptions, context.childAgeString, handlers]
  );
  return (
    <div className={block}>
      <label className={cn("label")}>{text.childIndexLabel}</label>
      <Popover>
        <PopoverTrigger className={cn("child-age-button", { popover: true })}>
          {childAgeButton}
        </PopoverTrigger>
        <PopoverContent
          className={cn("popover-content")}
          showCloseButton={false}
        >
          {childAgeRadio}
        </PopoverContent>
      </Popover>

      <Dialog>
        <DialogTrigger className={cn("child-age-button", { dialog: true })}>
          {childAgeButton}
        </DialogTrigger>
        <DialogContent
          title={text.dialogTitle}
          className={cn("dialog-content")}
          fullScreen={true}
          bottomFixedContent={
            <DialogClose className={cn("apply-button")}>
              {text.dialogDone}
            </DialogClose>
          }
        >
          {childAgeRadio}
        </DialogContent>
      </Dialog>
    </div>
  );
};
